/**
 * Umschaltbares System-Design (Jun-2026 · User-Wunsch).
 * „tw-orange" = echter Dunkelmodus (warmes Orange-Akzent), „default" =
 * ursprüngliches Gelb-Design. Gesetzt über data-theme am <html>.
 * Persistenz: lokal (localStorage) UND serverseitig im Profil (ui_theme),
 * damit jede(r) Nutzer(in) die bevorzugte Ansicht auf allen Geräten sieht.
 */
import api from "./api";
import { useEffect } from "react";

const KEY = "tw-theme";
const VALID = ["default", "tw-orange"];

export function getTheme() {
    try { return localStorage.getItem(KEY) || "default"; } catch { return "default"; }
}

export function applyTheme(theme) {
    const root = document.documentElement;
    if (theme === "tw-orange") root.setAttribute("data-theme", "tw-orange");
    else root.removeAttribute("data-theme");
}

export function setTheme(theme, { persist = false } = {}) {
    if (!VALID.includes(theme)) theme = "default";
    try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
    applyTheme(theme);
    if (persist) {
        api.put("/auth/me/ui-theme", { theme }).catch(() => { /* offline/anon — lokal genügt */ });
    }
}

export function initTheme() {
    applyTheme(getTheme());
}

// Vom Server geladene Präferenz anwenden (aus /auth/me). Gewinnt über den
// lokalen Wert, damit das Profil-Setting geräteübergreifend greift.
export function applyServerTheme(theme) {
    if (!VALID.includes(theme)) return;
    try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
    applyTheme(theme);
}

// Erzwingt den Dunkelmodus für die Dauer einer Seite (z. B. Login/Registrierung),
// ohne die gespeicherte Nutzer-Präferenz zu verändern. Stellt beim Verlassen
// die persistierte Einstellung wieder her.
export function useForceDarkTheme() {
    useEffect(() => {
        applyTheme("tw-orange");
        return () => { applyTheme(getTheme()); };
    }, []);
}
